import {
  SIMPLE_PROGRESSIVE_FORMS_CONFIG,
  SimpleProgressiveFormsConfigService,
} from '@innogy/common-ui/progressive-forms';
import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { TrackedToolComponent } from '@analytics/models';
import { TrackToolService } from '@analytics/events';
import { Store } from '@ngrx/store';
import throttle from 'lodash/throttle';

import type { InsulationOrderFormToolTrackingSteps } from '../../store';
import {
  insulationSelectorKey,
  parsedInsulationOrderFormToolTrackingConfig,
  selectInsulationOrderFormViewModel,
} from '../../store';
import { InsulationOrderFormRendering } from '../../models/insulation-order-form-rendering.interface';
import { initializeInsulationFunnelComponent } from '../../utils/initialize-insulation-funnel-component';

@Component({
  selector: 'wl-insulation-order-form',
  templateUrl: './insulation-order-form.component.html',
  providers: [
    {
      provide: SIMPLE_PROGRESSIVE_FORMS_CONFIG,
      useValue: {
        scrollIntoViewWhenActive: true,
        enableAutomaticFocusing: true,
        totalStepsInFlow: 2,
      },
    },
    SimpleProgressiveFormsConfigService,
  ],
})
export class InsulationOrderFormComponent
  implements OnInit, TrackedToolComponent<InsulationOrderFormToolTrackingSteps>
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InsulationOrderFormRendering;

  public viewModel$ = this.store$.select(selectInsulationOrderFormViewModel);
  public progressiveFormSelectorKey = insulationSelectorKey;

  completeTool = throttle(
    () => this.trackToolService.completeTool(this.trackToolConfig),
    2000,
    {
      trailing: false,
    }
  );

  constructor(
    protected readonly store$: Store,
    private readonly trackToolService: TrackToolService
  ) {}

  ngOnInit() {
    this.store$.dispatch(
      initializeInsulationFunnelComponent(
        'orderForm',
        this.rendering?.fields.FunnelSettings
      )
    );
  }

  get trackToolConfig() {
    const toolName = this.rendering.fields.componentName.value;
    return parsedInsulationOrderFormToolTrackingConfig(toolName);
  }
}
